export const PageComponent = {
	BriscoesImportOrderPage: "briscoesImportOrderPage",
	NZBloomExportBookingPage: "nzbloomExportBookingPage",
	BriscoesBulkUpdatePage: "briscoesBulkUpdatePage"
} as const;